import { reactEvents } from '@bridge/reactEvents';
import { createContextValue } from '@texas/utils/contextState';
import { useState, useEffect } from 'react';

export function useUrlParams() {
  const [params, setParams] = useState<any>({});
  useEffect(() => {
    const unsub = reactEvents.urlParamsChanged.sub((params) => {
      setParams(params);
    });

    return unsub;
  }, []);

  return params;
}

export const [UrlParamsProvider, useUrlParamsProvider] =
  createContextValue<ReturnType<typeof useUrlParams>>();
